import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Clock, Users, Phone, Check, Music, Heart, Sparkles, ExternalLink, Award } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../components/ui/tabs';
import { GrasrotandelenBanner } from '../components/GrasrotandelenBanner';
import { BarneMixSection } from '../components/BarneMixSection';
import { useTranslation } from 'react-i18next';
import { SEO } from '../components/SEO';

import i18n from '../i18n';
const t = (k, o) => i18n.t(k, o);

const DanseMixSection = () => (
  <div className="space-y-8">
    {/* Hero Card */}
    <div className="bg-white dark:bg-slate-800 rounded-2xl border border-slate-200 dark:border-slate-700 overflow-hidden">
      <div className="aspect-video relative">
        <img
          src="https://images.unsplash.com/photo-1508700929628-666bc8bd84ea?w=1200&q=80"
          alt={t('pg.DancePilates.26b718')}
          loading="lazy"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" />
        <div className="absolute bottom-0 left-0 right-0 p-6">
          <h2 className="text-3xl font-bold text-white mb-2">{t('pg.DancePilates.b593ad')}</h2>
          <p className="text-white/80">{t('pg.DancePilates.fef567')}</p>
        </div>
      </div>
    </div>

    {/* Dansemix ungdom og voksne */}
    <div className="bg-white rounded-xl border border-slate-200 p-6 md:p-8">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-12 h-12 bg-green-500/20 rounded-lg flex items-center justify-center">
          <Music className="w-6 h-6 text-green-500" />
        </div>
        <div>
          <h3 className="text-xl font-bold text-slate-900 dark:text-white">{t('pg.DancePilates.e3c879')}</h3>
          <p className="text-slate-500 dark:text-slate-400">{t('pg.DancePilates.3f66c6')}</p>
        </div>
      </div>

      <p className="text-slate-600 mb-6">
        {t('pg.DancePilates.c1bd73')}
      </p>

      <p className="text-slate-500 mb-6">
        {t('pg.DancePilates.fbd579')}
      </p>

      <div className="bg-slate-100 rounded-lg p-4 mb-6">
        <h4 className="text-slate-900 font-bold mb-3">{t('pg.DancePilates.2429db')}</h4>
        <div className="grid md:grid-cols-2 gap-2">
          <div className="flex items-center gap-2 text-slate-600 text-sm">
            <Check className="w-4 h-4 text-green-500" />
            {t('pg.DancePilates.d0cc81')}
          </div>
          <div className="flex items-center gap-2 text-slate-600 text-sm">
            <Check className="w-4 h-4 text-green-500" />
            {t('pg.DancePilates.81dfe6')}
          </div>
          <div className="flex items-center gap-2 text-slate-600 text-sm">
            <Check className="w-4 h-4 text-green-500" />
            {t('pg.DancePilates.f07d8b')}
          </div>
          <div className="flex items-center gap-2 text-slate-600 text-sm">
            <Check className="w-4 h-4 text-green-500" />
            {t('pg.DancePilates.bb86e8')}
          </div>
          <div className="flex items-center gap-2 text-slate-600 text-sm">
            <Check className="w-4 h-4 text-green-500" />
            {t('pg.DancePilates.3c0ed8')}
          </div>
          <div className="flex items-center gap-2 text-slate-600 text-sm">
            <Check className="w-4 h-4 text-green-500" />
            {t('pg.DancePilates.a47003')}
          </div>
        </div>
      </div>

      <div className="bg-slate-100/50 border border-slate-200 rounded-lg p-4">
        <p className="text-slate-600 text-sm">
          <strong className="text-slate-900 dark:text-white">{t('pg.DancePilates.f67dcb')}</strong> {t('pg.DancePilates.a22b41')}
        </p>
      </div>
    </div>

    {/* Sign up info */}
    <div className="bg-white rounded-xl border border-slate-200 p-6 md:p-8">
      <h3 className="text-xl font-bold text-slate-900 mb-4">{t('pg.DancePilates.6831ce')}</h3>
      
      <p className="text-slate-500 mb-4">
        {t('pg.DancePilates.99ed62')}
      </p>

      <div className="bg-green-500/10 border border-green-500/30 rounded-lg p-4 mb-6">
        <p className="text-slate-600 dark:text-slate-300">
          <strong className="text-green-500">{t('pg.DancePilates.c481e2')}</strong> {t('pg.DancePilates.70757c')}
        </p>
      </div>

      <div className="bg-slate-100 rounded-lg p-4">
        <h4 className="text-slate-900 font-bold mb-3">{t('pg.DancePilates.f85347')}</h4>
        <a href="tel:90725152" className="flex items-center gap-2 text-green-500 hover:underline text-lg">
          <Phone className="w-5 h-5" />
          90 72 51 52
        </a>
      </div>
    </div>
  </div>
);

const PilatesMixSection = () => (
  <div className="space-y-8">
    {/* Hero Card */}
    <div className="bg-white rounded-2xl border border-slate-200 overflow-hidden">
      <div className="aspect-video relative">
        <img
          src="https://images.unsplash.com/photo-1518611012118-696072aa579a?w=1200&q=80"
          alt={t('pg.DancePilates.292852')}
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" />
        <div className="absolute bottom-0 left-0 right-0 p-6">
          <h2 className="text-3xl font-bold text-slate-900 mb-2">{t('pg.DancePilates.4cff1a')}</h2>
          <p className="text-slate-600 dark:text-slate-300">{t('pg.DancePilates.1217d2')}</p>
        </div>
      </div>
    </div>

    {/* Main description */}
    <div className="bg-white rounded-xl border border-slate-200 p-6 md:p-8">
      <p className="text-xl text-slate-600 mb-6">
        {t('pg.DancePilates.508fb7')}
      </p>

      <div className="bg-green-500/10 border border-green-500/30 rounded-lg p-4">
        <p className="text-slate-600 dark:text-slate-300">
          <strong className="text-green-500">{t('pg.DancePilates.9963d1')}</strong> {t('pg.DancePilates.8660d5')}
        </p>
      </div>
    </div>

    {/* What you learn */}
    <div className="bg-white rounded-xl border border-slate-200 p-6 md:p-8">
      <h3 className="text-xl font-bold text-slate-900 mb-4">{t('pg.DancePilates.37d6ce')}</h3>
      <p className="text-slate-500 mb-4">{t('pg.DancePilates.500bd4')}</p>
      
      <ul className="space-y-3 mb-6">
        <li className="flex items-start gap-2 text-slate-600 dark:text-slate-300">
          <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
          {t('pg.DancePilates.f3763b')}
        </li>
        <li className="flex items-start gap-2 text-slate-600 dark:text-slate-300">
          <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
          {t('pg.DancePilates.7de0ec')}
        </li>
        <li className="flex items-start gap-2 text-slate-600 dark:text-slate-300">
          <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
          {t('pg.DancePilates.fd4704')}
        </li>
      </ul>

      <p className="text-slate-500 dark:text-slate-400">
        {t('pg.DancePilates.78af47')}
      </p>
    </div>

    {/* Who is it for */}
    <div className="bg-white rounded-xl border border-slate-200 p-6 md:p-8">
      <h3 className="text-xl font-bold text-slate-900 mb-4">{t('pg.DancePilates.27c720')}</h3>
      
      <div className="bg-green-500/10 border border-green-500/30 rounded-lg p-4 mb-6">
        <p className="text-2xl font-bold text-green-500 text-center">{t('pg.DancePilates.d62ad1')}</p>
      </div>

      <p className="text-slate-600 mb-6">
        {t('pg.DancePilates.2480f2')}
      </p>

      <div className="bg-slate-100/50 border border-slate-200 rounded-lg p-4">
        <p className="text-slate-500 text-sm">
          <strong className="text-slate-900 dark:text-white">{t('pg.DancePilates.f67dcb')}</strong> {t('pg.DancePilates.d3a191')}
        </p>
      </div>
    </div>

    {/* About Pilates */}
    <div className="bg-white rounded-xl border border-slate-200 p-6 md:p-8">
      <h3 className="text-xl font-bold text-slate-900 mb-4">{t('pg.DancePilates.9eae71')}</h3>
      
      <div className="mb-6">
        <h4 className="text-lg font-bold text-green-500 mb-2">{t('pg.DancePilates.d70dfd')}</h4>
        <p className="text-slate-500 dark:text-slate-400">
          {t('pg.DancePilates.30dd65')}
        </p>
      </div>

      <p className="text-slate-600 mb-6">
        {t('pg.DancePilates.5e9576')}
      </p>

      <h4 className="text-lg font-bold text-slate-900 mb-4">{t('pg.DancePilates.20318e')}</h4>
      <p className="text-slate-500 mb-4">{t('pg.DancePilates.404056')}</p>
      
      <div className="grid md:grid-cols-2 gap-3">
        <div className="flex items-center gap-2 text-slate-600 dark:text-slate-300">
          <Check className="w-4 h-4 text-green-500" />
          {t('pg.DancePilates.f2a23d')}
        </div>
        <div className="flex items-center gap-2 text-slate-600 dark:text-slate-300">
          <Check className="w-4 h-4 text-green-500" />
          {t('pg.DancePilates.783c70')}
        </div>
        <div className="flex items-center gap-2 text-slate-600 dark:text-slate-300">
          <Check className="w-4 h-4 text-green-500" />
          {t('pg.DancePilates.5a210d')}
        </div>
        <div className="flex items-center gap-2 text-slate-600 dark:text-slate-300">
          <Check className="w-4 h-4 text-green-500" />
          {t('pg.DancePilates.d9af83')}
        </div>
        <div className="flex items-center gap-2 text-slate-600 dark:text-slate-300">
          <Check className="w-4 h-4 text-green-500" />
          {t('pg.DancePilates.081b7e')}
        </div>
        <div className="flex items-center gap-2 text-slate-600 dark:text-slate-300">
          <Check className="w-4 h-4 text-green-500" />
          {t('pg.DancePilates.699860')}
        </div>
        <div className="flex items-center gap-2 text-slate-600 dark:text-slate-300">
          <Check className="w-4 h-4 text-green-500" />
          {t('pg.DancePilates.f35392')}
        </div>
      </div>
    </div>

    {/* What to bring */}
    <div className="bg-white rounded-xl border border-slate-200 p-6 md:p-8">
      <h3 className="text-xl font-bold text-slate-900 mb-4">{t('pg.DancePilates.563394')}</h3>
      
      <ul className="space-y-3 mb-6">
        <li className="flex items-start gap-2 text-slate-600 dark:text-slate-300">
          <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
          {t('pg.DancePilates.2c6599')}
        </li>
        <li className="flex items-start gap-2 text-slate-600 dark:text-slate-300">
          <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
          {t('pg.DancePilates.003109')}
        </li>
        <li className="flex items-start gap-2 text-slate-600 dark:text-slate-300">
          <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
          {t('pg.DancePilates.1e6e9a')}
        </li>
      </ul>

      <div className="bg-slate-100 rounded-lg p-4">
        <p className="text-slate-500 text-sm">
          <strong className="text-slate-900 dark:text-white">{t('pg.DancePilates.120f5f')}</strong> {t('pg.DancePilates.a190f8')}
        </p>
      </div>
    </div>

    {/* CTA */}
    <div className="bg-green-500/10 border border-green-500/30 rounded-xl p-6 md:p-8 text-center">
      <h3 className="text-2xl font-bold text-slate-900 mb-4">
        {t('pg.DancePilates.3194cc')}
      </h3>
      <p className="text-slate-600 mb-6">
        {t('pg.DancePilates.ba40fd')}
      </p>
      <p className="text-slate-500 mb-6">
        {t('pg.DancePilates.7296f5')}
      </p>
      
      <div className="bg-white rounded-lg p-4 inline-block">
        <h4 className="text-slate-900 font-bold mb-2">{t('pg.DancePilates.f85347')}</h4>
        <a href="tel:90725152" className="flex items-center justify-center gap-2 text-green-500 hover:underline text-xl">
          <Phone className="w-5 h-5" />
          90 72 51 52
        </a>
      </div>
    </div>
  </div>
);

const OverviewSection = ({ t }) => (
  <div className="space-y-8">
    {/* Intro */}
    <div className="text-center">
      <p className="text-slate-500 dark:text-slate-400 text-lg max-w-3xl mx-auto">
        {t('dance.overviewIntro', 'Velkommen til dans- og pilatesavdelingen i Veitvet Sportsklubb! Vi tilbyr timer for alle aldre og nivåer.')}
      </p>
    </div>

    {/* Stats */}
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
      <div className="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 p-6 text-center">
        <Sparkles className="w-8 h-8 text-green-500 mx-auto mb-3" />
        <p className="text-2xl font-bold text-slate-900 dark:text-white" data-testid="dance-activity-count">3</p>
        <p className="text-slate-500 dark:text-slate-400 text-sm">{t('dance.activities')}</p>
      </div>
      <div className="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 p-6 text-center">
        <Users className="w-8 h-8 text-green-500 mx-auto mb-3" />
        <p className="text-2xl font-bold text-slate-900 dark:text-white">{t('dance.everyone', 'Alle')}</p>
        <p className="text-slate-500 dark:text-slate-400 text-sm">{t('dance.allAgesWelcome')}</p>
      </div>
      <div className="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 p-6 text-center">
        <Heart className="w-8 h-8 text-green-500 mx-auto mb-3" />
        <p className="text-2xl font-bold text-slate-900 dark:text-white">15+</p>
        <p className="text-slate-500 dark:text-slate-400 text-sm">{t('dance.yearsExperience')}</p>
      </div>
    </div>

    {/* Activity Cards */}
    <div className="grid md:grid-cols-3 gap-6">
      {/* BarneMix Card */}
      <div className="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 overflow-hidden group hover:border-green-500/50 transition-all" data-testid="overview-barnemix-card">
        <div className="aspect-video relative overflow-hidden">
          <img
            src="/images/barnemix.jpg"
            alt={t('pg.DancePilates.a1fa9c')}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" />
          <div className="absolute bottom-0 left-0 right-0 p-4">
            <span className="bg-yellow-400 text-slate-900 text-xs font-bold px-2 py-1 rounded uppercase">{t('pg.DancePilates.fb50c0')}</span>
          </div>
        </div>
        <div className="p-6 space-y-3 text-sm text-slate-500 dark:text-slate-400">
          <h3 className="text-xl font-bold text-slate-900 dark:text-white">{t('pg.DancePilates.a1fa9c')}</h3>
          <p>
            {t('pg.DancePilates.d9586b')}
          </p>
          <p>
            {t('pg.DancePilates.d754eb')}
          </p>
          <p>
            {t('pg.DancePilates.afff7c')}
          </p>
        </div>
      </div>

      {/* Danse Mix Card */}
      <div className="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 overflow-hidden group hover:border-green-500/50 transition-all">
        <div className="aspect-video relative overflow-hidden">
          <img
            src="https://images.unsplash.com/photo-1508700929628-666bc8bd84ea?w=600&q=80"
            alt={t('pg.DancePilates.b593ad')}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" />
          <div className="absolute bottom-0 left-0 right-0 p-4">
            <span className="bg-pink-500 text-slate-900 text-xs font-bold px-2 py-1 rounded uppercase">{t('dance.danceLabel', 'Dans')}</span>
          </div>
        </div>
        <div className="p-6">
          <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-2">{t('dance.danceMix')}</h3>
          <p className="text-slate-500 dark:text-slate-400 text-sm mb-4">
            {t('dance.danceMixDesc')}
          </p>
          <ul className="space-y-1 text-sm text-slate-400 mb-4">
            <li>• {t('dance.youthAndAdultsShort', 'Ungdom og voksne')}: {t('dance.allLevels')}</li>
            <li>• {t('dance.freeTrial')}</li>
          </ul>
        </div>
      </div>

      {/* Pilates Mix Card */}
      <div className="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 overflow-hidden group hover:border-green-500/50 transition-all">
        <div className="aspect-video relative overflow-hidden">
          <img
            src="https://images.unsplash.com/photo-1518611012118-696072aa579a?w=600&q=80"
            alt={t('pg.DancePilates.292852')}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" />
          <div className="absolute bottom-0 left-0 right-0 p-4">
            <span className="bg-green-500 text-black text-xs font-bold px-2 py-1 rounded uppercase">{t('pg.DancePilates.703de7')}</span>
          </div>
        </div>
        <div className="p-6">
          <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-2">{t('dance.pilatesMix')}</h3>
          <p className="text-slate-500 dark:text-slate-400 text-sm mb-4">
            {t('dance.pilatesMixDesc', 'Rolig styrke for hele kroppen. Perfekt for alle aldre og nivåer, 13-70+ år.')}
          </p>
          <ul className="space-y-1 text-sm text-slate-400 mb-4">
            <li>• {t('dance.experiencedInstructor', 'Instruktør med 15+ års erfaring')}</li>
            <li>• {t('dance.gentleEffective', 'Skånsom men effektiv')}</li>
            <li>• {t('dance.perfectSupplement', 'Perfekt supplement til annen idrett')}</li>
          </ul>
        </div>
      </div>
    </div>

    {/* Instructor */}
    <div className="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 p-6 md:p-8" data-testid="dance-instructor-section">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-12 h-12 bg-green-500/20 rounded-lg flex items-center justify-center">
          <Award className="w-6 h-6 text-green-500" aria-hidden="true" />
        </div>
        <div>
          <h3 className="text-xl font-bold text-slate-900 dark:text-white">{t('pg.DancePilates.bcbc8b')}</h3>
          <p className="text-slate-500 dark:text-slate-400">{t('pg.DancePilates.8ea90f')}</p>
        </div>
      </div>
      <div className="space-y-4 text-slate-600 dark:text-slate-300 leading-relaxed">
        <p>
          <strong className="text-slate-900 dark:text-white">{t('pg.DancePilates.8ea90f')}</strong> {t('pg.DancePilates.aa0c14')}
        </p>
        <p>
          {t('pg.DancePilates.6a9a4c')}
        </p>
        <p>
          {t('pg.DancePilates.b71987')}
        </p>
      </div>
      <div className="bg-green-500/10 border border-green-500/30 rounded-lg p-4 mt-6">
        <p className="text-green-600 dark:text-green-400 font-bold text-center">
          {t('pg.DancePilates.a56f57')}
        </p>
      </div>
    </div>

    {/* Pricing */}
    <div className="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 p-6 md:p-8">
      <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-6 text-center">{t('dance.trainingFees')}</h3>
      <div className="max-w-md mx-auto" data-testid="dance-pricing-table">
        <table className="w-full">
          <tbody>
            <tr className="border-b border-slate-200 dark:border-slate-700">
              <td colSpan={2} className="pt-3 pb-1 font-bold text-slate-900 dark:text-white">{t('pg.DancePilates.85d0ab')}</td>
            </tr>
            <tr className="border-b border-slate-200 dark:border-slate-700">
              <td className="py-3 text-slate-600 dark:text-slate-300">{t('pg.DancePilates.a1fa9c')}</td>
              <td className="py-3 text-right text-green-500 font-bold">kr 1 100</td>
            </tr>
            <tr className="border-b border-slate-200 dark:border-slate-700">
              <td colSpan={2} className="pt-5 pb-1 font-bold text-slate-900 dark:text-white">{t('pg.DancePilates.4b056b')}</td>
            </tr>
            <tr className="border-b border-slate-200 dark:border-slate-700">
              <td className="py-3 text-slate-600 dark:text-slate-300">{t('pg.DancePilates.6d83d2')}</td>
              <td className="py-3 text-right text-green-500 font-bold">kr 1 400</td>
            </tr>
            <tr className="border-b border-slate-200 dark:border-slate-700">
              <td colSpan={2} className="pt-5 pb-1 font-bold text-slate-900 dark:text-white">{t('pg.DancePilates.ea2c71')}</td>
            </tr>
            <tr className="border-b border-slate-200 dark:border-slate-700">
              <td className="py-3 text-slate-600 dark:text-slate-300">{t('pg.DancePilates.bbe639')}</td>
              <td className="py-3 text-right text-green-500 font-bold">kr 1 600</td>
            </tr>
            <tr className="border-b border-slate-200 dark:border-slate-700">
              <td className="py-3 text-slate-600 dark:text-slate-300">{t('pg.DancePilates.4cff1a')}</td>
              <td className="py-3 text-right text-green-500 font-bold">kr 1 600</td>
            </tr>
            <tr>
              <td className="py-3 text-slate-600 dark:text-slate-300">{t('pg.DancePilates.6d83d2')}</td>
              <td className="py-3 text-right text-green-500 font-bold">kr 2 200</td>
            </tr>
          </tbody>
        </table>
        <p className="text-slate-500 dark:text-slate-400 text-sm mt-4 text-center" data-testid="dance-membership-note">
          {t('pg.DancePilates.04287d')}
        </p>
      </div>
      <div className="text-center mt-6">
        <Link to="/pricing">
          <Button variant="outline" className="border-slate-300 dark:border-slate-600 text-slate-900 dark:text-white hover:bg-slate-100 dark:hover:bg-slate-700">
            {t('dance.seeAllPrices')}
          </Button>
        </Link>
      </div>
    </div>

    {/* Contact */}
    <div className="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 p-6 text-center">
      <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-4">{t('dance.contactDanceGroup')}</h3>
      <p className="text-slate-500 dark:text-slate-400 mb-4">{t('dance.forQuestionsSignup', 'For spørsmål og påmelding')}</p>
      <a href="tel:90725152" className="inline-flex items-center gap-2 text-green-500 hover:underline text-2xl font-bold">
        <Phone className="w-6 h-6" />
        90 72 51 52
      </a>
    </div>
  </div>
);

export const DancePilates = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('oversikt');

  return (
    <div data-testid="dance-pilates-page">
      <SEO 
        title={t('pg.DancePilates.2ef8db')} 
        description={t('pg.DancePilates.5eac5f')}
      />
      {/* Hero Section */}
      <section className="relative min-h-[50vh] flex items-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://images.unsplash.com/photo-1518611012118-696072aa579a?w=1920&q=80"
            alt={t('pg.DancePilates.dd3179')}
            loading="eager"
            className="w-full h-full object-cover opacity-40"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-slate-900 via-slate-900/70 to-transparent" />
        </div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
          <p className="text-green-400 font-medium uppercase tracking-widest mb-4">{t('dance.movementStudio')}</p>
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold tracking-tighter text-white mb-6">
            {t('dance.heroTitle')}<br />
            <span className="text-green-400">{t('dance.heroTitle2')}</span>
          </h1>
          <p className="text-xl text-white/90 max-w-2xl">
            {t('dance.heroDescription')}
          </p>
        </div>
      </section>

      {/* Tabs Section */}
      <section className="py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-5xl mx-auto">
          <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
            <TabsList className="w-full flex flex-wrap justify-center gap-2 bg-transparent h-auto mb-8">
              <TabsTrigger 
                value="oversikt" 
                data-testid="tab-oversikt"
                className="data-[state=active]:bg-green-500 data-[state=active]:text-black bg-slate-100 dark:bg-slate-700 text-slate-900 dark:text-white px-6 py-3 rounded-lg font-bold uppercase tracking-wider"
              >
                {t('dance.overview')}
              </TabsTrigger>
              <TabsTrigger 
                value="barnemix" 
                data-testid="tab-barnemix"
                className="data-[state=active]:bg-green-500 data-[state=active]:text-black bg-slate-100 dark:bg-slate-700 text-slate-900 dark:text-white px-6 py-3 rounded-lg font-bold uppercase tracking-wider flex items-center gap-2"
              >
                <Sparkles className="w-4 h-4" />
                {t('pg.DancePilates.a1fa9c')}
              </TabsTrigger>
              <TabsTrigger 
                value="dansemix" 
                data-testid="tab-dansemix"
                className="data-[state=active]:bg-green-500 data-[state=active]:text-black bg-slate-100 dark:bg-slate-700 text-slate-900 dark:text-white px-6 py-3 rounded-lg font-bold uppercase tracking-wider flex items-center gap-2"
              >
                <Music className="w-4 h-4" />
                {t('dance.danceMix')}
              </TabsTrigger>
              <TabsTrigger 
                value="pilatesmix" 
                data-testid="tab-pilatesmix"
                className="data-[state=active]:bg-green-500 data-[state=active]:text-black bg-slate-100 dark:bg-slate-700 text-slate-900 dark:text-white px-6 py-3 rounded-lg font-bold uppercase tracking-wider flex items-center gap-2"
              >
                <Heart className="w-4 h-4" />
                {t('dance.pilatesMix')}
              </TabsTrigger>
            </TabsList>

            <TabsContent value="oversikt">
              <OverviewSection t={t} />
            </TabsContent>

            <TabsContent value="barnemix">
              <BarneMixSection />
            </TabsContent>

            <TabsContent value="dansemix">
              <DanseMixSection />
            </TabsContent>

            <TabsContent value="pilatesmix">
              <PilatesMixSection />
            </TabsContent>
          </Tabs>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 px-4 sm:px-6 lg:px-8 bg-white dark:bg-slate-800">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl font-bold tracking-tighter text-slate-900 dark:text-white mb-4">
            {t('dance.joinToday')}
          </h2>
          <p className="text-slate-500 dark:text-slate-400 text-lg mb-8">
            {t('dance.joinTodayDesc')}
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <a 
              href="https://app.hoopit.io/join/veitvet-sportsklubb-532465/open?skipWelcome=true&push=true"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button className="bg-green-500 text-black font-bold uppercase tracking-wider px-8 py-6 hover:bg-green-500/90">
                {t('home.joinNow')}
                <ExternalLink className="ml-2 w-5 h-5" />
              </Button>
            </a>
            <Link to="/contact">
              <Button variant="outline" className="border-slate-300 dark:border-slate-600 text-slate-900 dark:text-white uppercase tracking-wider px-8 py-6 hover:bg-slate-100 dark:hover:bg-slate-700">
                {t('soccer.contactUs')}
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* Grasrotandelen Banner */}
      <GrasrotandelenBanner />
    </div>
  );
};

export default DancePilates;
